import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SidePanelComponent } from './side-panel.component';
import { MatIconModule } from '@angular/material/icon';
import { BannerComponent } from 'src/app/shared/banner.component';

@NgModule({
    declarations: [SidePanelComponent],
    providers: [],
    exports: [SidePanelComponent],
    imports: [CommonModule, MatIconModule, BannerComponent]
})
export class SidePanelModule {}
